import {  getAll, getById, remove, update } from "./baseService";

const courseService = {
  getAllCourses: () => {
    return getAll('courses')
  },
  getMyCourses: () => {
    return getAll('courses/getMe')
  },
  getCourseById: (course_id) => {
    return getById('courses',course_id)
  },
  updateCourse: (course_id,course) => {
    return update('courses',course_id,course)
  },
  deleteCourse: (course_id) => {
    return remove('courses',course_id)
  },


}

export default courseService
